import React from 'react';
import ReactDOM from 'react-dom';
import { StandaloneNotification } from '@wix/marketplace-component';
import { ToastConfig } from '@wix/business-manager-api';

function showToast(toastOptions: ToastConfig): void {
  const notificationsContainer: Element = document.getElementById(
    'notifications-root',
  );
  ReactDOM.render(
    <StandaloneNotification {...toastOptions} />,
    notificationsContainer,
  );
}

export { showToast };
